(function() {

    'use strict';

    angular.module('eclipseApp.myAccount').controller('billingEnhancementMobileModalCtrl', ['$scope', '$rootScope', 'uteLocale', '$modalInstance', function($scope, $rootScope, uteLocale, $modalInstance) {

        console.log('billingEnhancementMobileModalCtrl');

        $scope.billEnhanceLang = uteLocale.language;



    }]);

})();
